import { Action } from '@ngrx/store';
import { IRace } from 'src/app/models/race.interface';

export enum EEventActions {
    GetEvent = '[Event] Get Event',
    GetEventSuccess = '[Event] Get Event Success',
    GetResetEvent = '[Event] Get Reset Event'
}

export class GetEvent implements Action {
    public readonly type = EEventActions.GetEvent;
    constructor(public payload: number) {}
}

export class GetEventSuccess implements Action {
    public readonly type = EEventActions.GetEventSuccess;
    constructor(public payload: IRace[]) {}
}

export class GetResetEvent implements Action {
    public readonly type = EEventActions.GetResetEvent;
    constructor(public payload: any) {}
}


export type EventActions =
 | GetEvent
 | GetEventSuccess
 | GetResetEvent;
